<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <p class="page-header lead">
            <i class="fa fa-user"></i> {{ titleText }}
          </p>
        </div>
      </div>
      <div v-if="isLoading" class="row">
        <Preloader />
      </div>
      <div v-else class="row">
        <div
          v-for="card in cards"
          :key="card.link"
          v-if="userHasPermission(card)"
          class="col-lg-3 col-md-6"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i :class="`fa fa-4x ${card.icon}`"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>{{ card.label }}</div>
                </div>
              </div>
            </div>
            <router-link :to="card.link">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"
                  ><i class="fa fa-arrow-circle-right"></i
                ></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mainPage } from "@/user/constants";
import { useRoleIdentifier } from "@/_shared/mixins";
import { userService } from "@/user/api-services";
import Preloader from "@/_shared/components/ui/Preloader";
export default {
  components: {
    Preloader,
  },
  mixins: [useRoleIdentifier],
  data() {
    return {
      cards: mainPage.cards,
      user: {},
      isLoading: true,
    };
  },
  computed: {
    titleText() {
      if (this.isLoading) {
        return 'Загрузка...';
      }
      return `Добро пожаловать, ${this.user.fullname}`;
    },
  },
  async mounted() {
    await userService.getMyUser().then((results) => {
      this.user = results.record;
      this.isLoading = false;
    });
  },
};
</script>

<style scoped>
.row_preloader {
  height: 500px;
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/user/pages/MainPage.vue